import { Box, Button, IconButton, Stack, Typography } from '@mui/material';
import { AttachFile as AttachFileIcon, DeleteOutline as DeleteIcon } from '@mui/icons-material';
import { useRef } from 'react';

type FinanceEmailComposeAttachmentsProps = {
  files: File[];
  onChange: (files: File[]) => void;
  disabled?: boolean;
};

export const FinanceEmailComposeAttachments = ({
  files,
  onChange,
  disabled = false,
}: FinanceEmailComposeAttachmentsProps) => {
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const handleAddFiles = (selected: FileList | null) => {
    if (!selected || selected.length === 0) {
      return;
    }
    onChange([...files, ...Array.from(selected)]);
  };

  const handleRemoveFile = (index: number) => {
    onChange(files.filter((_, i) => i !== index));
  };

  return (
    <Box>
      <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
        <Typography
          variant="body2"
          fontWeight={700}
          sx={{ color: disabled ? 'text.disabled' : 'text.primary' }}
        >
          Attachments
        </Typography>
        <Button
          size="small"
          startIcon={<AttachFileIcon />}
          onClick={() => fileInputRef.current?.click()}
          disabled={disabled}
          sx={{ textTransform: 'none' }}
        >
          Add files
        </Button>
        <input
          ref={fileInputRef}
          type="file"
          multiple
          hidden
          onChange={(event) => {
            handleAddFiles(event.target.files);
            event.target.value = '';
          }}
        />
      </Stack>

      <Stack spacing={0.5}>
        {files.map((file, index) => (
          <Stack
            key={`${file.name}-${file.size}-${index}`}
            direction="row"
            spacing={1}
            alignItems="center"
          >
            <Typography variant="body2" sx={{ flex: 1, wordBreak: 'break-word' }}>
              {file.name}
            </Typography>
            <IconButton
              size="small"
              onClick={() => handleRemoveFile(index)}
              disabled={disabled}
              aria-label={`Remove ${file.name}`}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Stack>
        ))}
        {files.length === 0 && (
          <Typography variant="body2" color="text.secondary">
            No files selected
          </Typography>
        )}
      </Stack>
    </Box>
  );
};
